// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".willding-price-widget{border:1px solid #27a099;text-align:left;padding:5px;margin:10px 50px}.willding-price-widget-sum{border-top:2px solid #000;border-bottom:1px double #000;padding:4px 0}.willding-price-widget>div{display:grid;grid-template-columns:120px auto;padding:4px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
